import { Button, Input, List, Typography } from "antd";
import { getFullName } from "../../../../utils/shared";
import Avatar from "../../../../components/generic/Avatar";
import { EditOutlined, SaveOutlined, CloseOutlined } from "@ant-design/icons";
import { convertDateToFromNow } from "../../../../utils/dayjs";
import { useMemo } from "react";
import Reactions from "../../../../components/shared/Reactions";
import { setKeyValue } from "../../../../store/tasks/slice";
import { useDispatch } from "react-redux";
import ReactionsList from "../../../../components/shared/Reactions/ReactionsList";
import { MentionInput } from "../../../../components/shared/Mentions";
import { renderContentWithLinks } from "../../Chats/ChatWindow/MessageItem/LinkUtils";
const { Text } = Typography;

const CommentItem = ({
  comment,
  editingId,
  handleEdit,
  editValue,
  setEditValue,
  handleEditCancel,
  handleEditSave,
  loggedUser,
  isSubmitting,
  users,
}) => {
  const { commenter, content, id, user_id, updated_at } = comment;

  const isOwner = useMemo(
    () => loggedUser?.user_id === user_id,
    [loggedUser, user_id],
  );

  const dispatch = useDispatch();
  const isEditing = useMemo(() => editingId === id, [editingId, id]);

  return (
    <List.Item className="comment-item" key={id}>
      <div className="comment-wrapper">
        <Avatar user={commenter} size={36} />
        <div className="comment-body">
          <div className="comment-header">
            <div className="comment-header-left">
              <Text className="comment-author" strong>
                {getFullName(commenter)}
              </Text>
              <Text className="comment-date">
                {convertDateToFromNow(updated_at)}
              </Text>
            </div>
            {isOwner && !isEditing && (
              <div className="comment-actions">
                <Button
                  icon={<EditOutlined />}
                  size="small"
                  color="primary"
                  variant="text"
                  onClick={() => handleEdit(comment)}
                />
              </div>
            )}
          </div>
          {isEditing ? (
            <div className="comment-edit-area">
              <MentionInput
                autoSize={{ minRows: 2, maxRows: 5 }}
                className="comment-edit-input"
                value={editValue}
                onChange={(value) => setEditValue(value)}
                disabled={isSubmitting}
                users={users}
              />
              <div className="comment-edit-actions">
                <Button
                  icon={<SaveOutlined />}
                  size="small"
                  type="primary"
                  onClick={() =>
                    handleEditSave({ content: editValue, isEdit: true })
                  }
                  disabled={isSubmitting}
                  loading={isSubmitting}
                >
                  Save
                </Button>
                {!isSubmitting && (
                  <Button
                    icon={<CloseOutlined />}
                    size="small"
                    onClick={handleEditCancel}
                  >
                    Cancel
                  </Button>
                )}
              </div>
            </div>
          ) : (
            <Text className="comment-content">
              {renderContentWithLinks({ text: content, users })}
            </Text>
          )}
          {!isEditing && (
            <div className="comment-footer">
              <Reactions
                reactions={comment?.reactions}
                loggedUser={loggedUser}
                onClickReaction={(emoji) =>
                  handleEditSave({ emoji, id: comment?.id })
                }
              />
              {!!comment?.reactions?.length && (
                <ReactionsList
                  reactions={comment?.reactions}
                  onClick={() => {
                    dispatch(
                      setKeyValue({
                        key: "reactions",
                        value: comment?.reactions,
                      }),
                    );
                  }}
                />
              )}
            </div>
          )}
        </div>
      </div>
    </List.Item>
  );
};
export default CommentItem;
